import { FunctionComponent } from "react";
import { CopyContent, Text } from "@kanda-libs/ks-design-library";
import clsx from "clsx";

export interface PropertyProps {
  label: string;
  value?: string | number | JSX.Element;
  valueToCopy?: string;
  className?: string;
  children?: JSX.Element;
  clickToCopy?: boolean;
}

const Property: FunctionComponent<PropertyProps> = function ({
  label,
  value,
  valueToCopy,
  className = "",
  children = null,
  clickToCopy = true,
}) {
  const innerContent = (
    <Text
      text={value as string | JSX.Element}
      className="text-14-22 text-neutral-700"
    />
  );

  const content = clickToCopy ? (
    <CopyContent content={valueToCopy || (value as string)}>
      {innerContent}
    </CopyContent>
  ) : (
    innerContent
  );

  return (
    <div className={clsx("flex flex-row mb-1", className)}>
      <Text
        text={`${label}:`}
        className="mr-2 text-14-22 text-neutral-700 min-w-32"
      />
      {children || content}
    </div>
  );
};

export default Property;
